import { StyleSheet } from "react-native";

import AppTheme from "./AppTheme";

import * as commonUtils from "./utils/services/CommonUtils";


const OmsStyles = StyleSheet.create(commonUtils.addFontFamilylato({
    bsView: { backgroundColor: AppTheme.color.white, paddingVertical: 16, borderTopLeftRadius: 12, borderTopRightRadius: 12 },
    modelView: { backgroundColor: AppTheme.color.white, margin: 16, borderRadius: 12, },
    favContainer: {
        height: 46, width: 51, position: 'absolute', top: -26, left: 16,
        display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#F7F7F8', borderRadius: 12, borderWidth: 1, borderColor: '#CECECE'
    },
    text9b: {
        fontSize: 9,
        color: AppTheme.color.black,
        fontWeight: 600
    },
    text9: {
        fontSize: 9,
        color: AppTheme.color.black,
    },
    text9xb: {
        fontSize: 9,
        color: AppTheme.color.black,
        fontFamily: 'Lato_900Black'
    },
    text10: {
        fontSize: 10,
        color: AppTheme.color.black,
    },
    text10b: {
        fontSize: 10,
        color: AppTheme.color.black,
        fontWeight: 600
    },
    text10xb: {
        fontSize: 10,
        color: AppTheme.color.black,
        fontFamily: 'Lato_900Black'
    },
    text11: {
        fontSize: 11,
        color: AppTheme.color.black,
    },
    text11b: {
        fontSize: 11,
        color: AppTheme.color.black,
        fontWeight: 600,

    },
    text11xb: {
        fontSize: 11,
        color: AppTheme.color.black,
        fontWeight: 600,
        fontFamily: 'Lato_900Black'
    },
    text12: {
        fontSize: 12,
        color: AppTheme.color.black,
    },
    text12b: {
        fontSize: 12,
        color: AppTheme.color.black,
        fontWeight: 600
    },
    text12xb: {
        fontSize: 12,
        color: AppTheme.color.black,
        fontFamily: 'Lato_900Black'
    },
    text14: {
        fontSize: 14,
        color: AppTheme.color.black,
    },
    text14xb: {
        fontSize: 14,
        color: AppTheme.color.black,
        fontFamily: 'Lato_900Black'
    },
    text14b: {
        fontSize: 14,
        color: AppTheme.color.black,
         // fontWeight: 600,
         fontFamily: 'Lato_700Bold'
    },
    text16: {
        fontSize: 16,
        color: AppTheme.color.black,
    },
    text16b: {
        fontSize: 16,
        color: AppTheme.color.black,
        // fontWeight: 600,
        fontFamily: 'Lato_700Bold'
    },
    text16xb: {
        fontSize: 16,
        color: AppTheme.color.black,
        fontFamily: 'Lato_900Black'
    },
    text20: {
        fontSize: 20,
        color: AppTheme.color.black,
    },
    text20b: {
        fontSize: 20,
        color: AppTheme.color.black,
        fontWeight: 600
    },
    text20xb: {
        fontSize: 20,
        color: AppTheme.color.black,
        fontFamily: 'Lato_900Black'
    },

    text24xb: {
        fontSize: 24,
        color: AppTheme.color.black,
        fontFamily: 'Lato_900Black'
    },

    omsHr: {
        backgroundColor: '#DDDDDD', marginVertical: 12,
        height: 1, marginBottom: 8
    },

    omsCardShadow: {
        shadowRadius: 6, shadowOffset: { width: 0, height: 3 }, shadowColor: '#00000029'
    },

    borderRadiusBottom: {
        borderBottomLeftRadius: 12,
        borderBottomRightRadius: 12,
    },

    flexRowSpaceAround: {
        display: 'flex', flexDirection: 'row', justifyContent: 'space-around', alignItems: 'center'
    },
    reviewBtn: {
        fontSize: 14,
        fontWeight: 600,
        color: '#fff',
        backgroundColor: AppTheme.color.primary,
        paddingVertical: 14,
        paddingHorizontal: 20,
        textAlign: 'center',
        borderRadius: 48
    },

    bottomFix: {
        position: 'fixed',
        bottom: 0,
        padding: 16,
        backgroundColor: '#fff',
        width: AppTheme.appWidth
    },
    bottonSheetview: {
        justifyContent: 'flex-end',
        margin: 'auto',
        width: AppTheme.appWidth,
    },
    addToText: {
        fontSize: 16, fontWeight: 600, color: AppTheme.color.primary, textAlign: 'center', alignVertical: 'center',
        display: 'flex', justifyContent: 'center', flexDirection: 'row',
        alignItems: 'center',
    },

    boxShadow: {
        shadowColor: "#00000029",
        zIndex: 1, shadowOpacity: 0.3, shadowRadius: 6, shadowOffset: {
            height: 3,
            width: 0
        }
    },

    boxShadowWithSpace: {
        borderRadius: 12,
        padding: 16, margin: 16,
        shadowColor: "#00000029",
        zIndex: 1, shadowOpacity: 0.3, shadowRadius: 6, shadowOffset: {
            height: 3,
            width: 0
        }, backgroundColor: AppTheme.color.white
    },
    flexContainer: {
        // width: '100%',
        zIndex: 9,
        margin: 'auto',
        flex: 1,
        flexDirection: 'row',
        flexWrap: 'wrap',
        marginLeft: 4,

    },
    flexItem: {
        margin: 8,
        borderRadius: 12
    },
    otherProduct: {
        padding: 8, marginLeft: 12, borderRadius: 12, width: AppTheme.appWidth / 2 - 24, backgroundColor: AppTheme.color.white
    },
    product: { padding: 12, marginRight: 12, borderRadius: 8, width: AppTheme.appWidth * 0.8, backgroundColor: AppTheme.color.white },
    productHead: {
        width: 100, height: 100, borderRadius: 8,
    },
    name: {
        fontSize: 14,
        color: AppTheme.color.black,
        flexGrow: 2,
    },
    productImage: {
        width: 100, height: 100, borderRadius: 8,
    },
    flexRowWrap: { display: 'flex', flexDirection: 'row', justifyContent: 'center', flexWrap: 'wrap' },
    inPageLoader: {
        position: 'fixed', top: 76,
        zIndex: 1, backgroundColor: AppTheme.color.white,
        width: 50,
        margin: 'auto',
        borderRadius: 50,
        height: 50,

        padding: 8, shadowColor: AppTheme.color.grey,
        shadowOpacity: 0.3, shadowRadius: 5,
    },
    commonTextColor: {
        color: '#0A0A0A'
    },
    disabledBtn: {
        // textAlign: 'center',
        // gap: 10,
        backgroundColor: 'lightgray',
        color: 'gray'
    },
}))

export default OmsStyles;